
import {typesAddressdet} from './svtypes/addressdet'


/*
//http://svabode-1420502022.us-west-1.elb.amazonaws.com/account/addressDetail
//POST http://localhost:8080/account/addressDetail
http://localhost:8086/account/addressDetail
rq
{
 "id":3
}



*/
let initStore = {
    loading: false,
    error: false,
    errob :{
        "timestamp": "2015-08-23T02:27:18.038+0000",
        "status": 500,
        "error": "Default Error",
        "message": "500 null",
        "path": "/kk/svaddressDetailPost"
    },
    crud_flag: 'I',
    crudsuccessob :{
        "timestamp": "2015-08-23T02:27:18.038+0000",
        "status": 200,
        "error": "Default Error",
        "message": "500 null",
        "path": "/kk/svaddressDetailPost"
    },
    
    my_data_geo:{
        "countryTypes": [
            {
                "name": "United STates America",
                "a2": "US",
                "a3": "USA",
                "value": "USA",
                "isonum": "840"
            },
            {
                "name": "Canada",
                "isdcode": "01",
                "a2": "CA",
                "a3": "CAN",
                "value": "CAN",
                "isonum": "124"
            }
        ],
        "stateTypes": [
            {
                "name": "California",
                "value": "CA",
                "a2": "CA"
            },
            {
                "name": "New York",
                "value": "NY",
                "a2": "NY"
            },
            {
                "name": "Texas",
                "value": "TX",
                "a2": "TX"
            }
        ],
        "isdcodeTypes": [
            {
                "name": "United States Of America(+1)",
                "value": "1"
            },
            {
                "name": "Australia(+61)",
                "value": "61"
            },
            {
                "name": "Spain(+34)",
                "value": "34"
            }
        ],
        "genderTypes": [
            {
                "name": "CL_MALE",
                "value": "MALE"
            },
            {
                "name": "CL_FEMALE",
                "value": "FEMALE"
            }
        ]
    },
    
    my_data_addressdet: {
        "id": -11,
        "fname": "",
        "lname": "",
        "gender":"MALE",
        "dateOfBirth":"1982-01-19",
        "email": "",
        "address": "",
        "city": "Albany",
        "state": "",
        "zip": "",
        "country": "AUS",
        "isdcode": "+1",
        "phone": ""
    },
    my_data_addressdet_svbak: {
        "id": 1,
        "fname": "John",
        "lname": "Glen",
        "gender":"MALE",
        "dateOfBirth":"1982-01-19",
        "email": "john123@yahoo.com",
        "address": "12 scotland av",
        "city": "Albany",
        "state": "New York",
        "zip": "12110",
        "country": "USA",
        "isdcode": "+1",
        "phone": "5121234356"
    }
}

export default (state = initStore, action) => {
    console.log(action);
    let januState;
    switch (action.type) {
       
        case "GET_ADDRESSDET_SUCCESS":
            console.log("reduce %%%%%%%%evsearcg  success*****************");
            console.log(action.payload.my_data_addressdet);
             //let januState = {...state, loading: false, my_data_addressdet: action.payload.my_data_addressdet}
            let januState = {...state,errob:null, loading: false,error:false, crud_flag:'I',my_data_geo:action.payload.my_data_geo, my_data_addressdet: action.payload.my_data_addressdet, svr_soj_images: action.payload.my_images}
            return januState
       
        case 'GET_ADDRESSDET_BEGIN':
            console.log("loading")
            return {...state,crud_flag:'I', error:false, loading: true}
        case 'GET_ADDRESSDET_ERROR':
            console.log("error")
            console.log(action.payload.errob)
            const errjson = {
                "timestamp": "2024-08-23T02:27:18.038+0000",
                "status": 500,
                "error": "Internal Server Error",
                "message": "500 null",
                "path": "/accountclient/svaddressDetailPost"
            }
            return {...state,errob:action.payload.errob,crudsuccessob:null, error: true}
        
        case "RESET_SAVEADDRESS_INIT":
           let  my_data_address_init = {
            "id": -11,
            "fname": "",
            "gender":"MALE",
            "dateOfBirth":"1982-01-19",
            "lname": "",
            "email": "",
            "address": "",
            "city": "Albany",
            "state": "",
            "zip": "",
            "country": "",
            "isdcode": "+1",
            "phone": ""
        }
            console.log("reduce j15v%%%%%%%%RESET_SAVEADDRESS_INIT  success*****************");
            console.log(action)
           
            /*
            januState = {...state, crud_flag:'I', error:false, loading:false, crudsuccessob:null,my_data_geo:action.payload.my_data_geo, my_data_addressdet:my_data_address_init}
            
           */
            if(action && action.payload && action.payload.my_data_geo){
                januState = {...state, crud_flag:'I', error:false, loading:false, crudsuccessob:null,my_data_geo:action.payload.my_data_geo, my_data_addressdet:my_data_address_init}

            }else{
                januState = {...state, crud_flag:'I', error:false, loading:false, crudsuccessob:null, my_data_addressdet:my_data_address_init}

            }
            return januState
               
        case "GET_SAVEADDRESS_SUCCESS":
                console.log("reduce %%%%%%%%evsearcg  success*****************");
                console.log(action.payload.crudsuccessob);
                // let januState = {...state, loading: false, my_data_addressdet: action.payload.my_data_addressdet}
                 januState = {...state, crud_flag:'S', error: true,loading: false, errob:null,crudsuccessob: action.payload.crudsuccessob}
                return januState
        case "GET_SAVEADDRESS_BEGIN":
                    console.log("loading")
                    return {...state, crud_flag:'I',loading: true}
        case "GET_SAVEADDRESS_ERROR":
                    console.log("crud error")
                    console.log(action.payload.errob)
                   
                    return {...state,errob:action.payload.errob,crudsuccessob:null, error: true, crud_flag:'E'}
        
        default:
            return state
    }
}